export default "__VITE_ASSET__mzGPRUD3__"